import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import LeadAttachmentsContainer from '../LeadAttachments.container'
import LeadFollowUpsContainer from '../LeadFollowUps.container'
import LeadNotesContainer from '../LeadNotes.container'
import LeadContactsContainer from '../LeadContacts.container'
import LeadEstimatesContainer from '../LeadEstimates.container'
import LeadProposalsContainer from '../LeadProposals.container'
import LeadContractsContainer from '../LeadContracts.container'
import LeadRFIsContainer from '../LeadRFIs.container'
import LeadTransmittalsContainer from '../LeadTransmittals.container'

class LeadRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path="/lead/:leadId/attachments/edit/:attachmentId"
          render={props => <LeadAttachmentsContainer {...props} {...this.props} />}
        />
        <Route
          path="/lead/:leadId/attachments"
          render={props => <LeadAttachmentsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/attachments/add/"
          render={props => <LeadAttachmentsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/followups"
          render={props => <LeadFollowUpsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/followups/edit/:followUpId"
          render={props => <LeadFollowUpsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/followups/add"
          render={props => <LeadFollowUpsContainer {...props} {...this.props} />}
        />
        <Route
          path="/lead/:leadId/notes"
          render={props => <LeadNotesContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/contacts"
          render={props => <LeadContactsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/estimates/add"
          render={props => <LeadEstimatesContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/estimates/edit/:estimateId"
          render={props => <LeadEstimatesContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/estimates/clone/:estimateId"
          render={props => <LeadEstimatesContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/estimates"
          render={props => <LeadEstimatesContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/proposals/add"
          render={props => <LeadProposalsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/proposals/edit/:proposalId"
          render={props => <LeadProposalsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/proposals/clone/:proposalId"
          render={props => <LeadProposalsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/proposals"
          render={props => <LeadProposalsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/contracts/add"
          render={props => <LeadContractsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/contracts/edit/:contractId"
          render={props => <LeadContractsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/contracts"
          render={props => <LeadContractsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/rfis"
          render={props => <LeadRFIsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId/transmittals"
          render={props => <LeadTransmittalsContainer {...props} {...this.props} />}
        />
        <Route
          exact
          path="/lead/:leadId"
          render={props => <LeadAttachmentsContainer {...props} {...this.props} />}
        />
        <Redirect to="/dashboard" />
      </Switch>
    )
  }
}

export default LeadRoutes



// WEBPACK FOOTER //
// ./src/pages/lead/routes/routes.js